// InvoiceViewItemBase Component
/* eslint indent: 0 */

import React, { Component } from 'react'
import ReactSelect from 'react-select'
import PropTypes from 'prop-types'
import _ from 'lodash'
import ReactDOM from 'react-dom'
import classnames from 'classnames'

import app from '../../../app.jsx'
import currency from '../../../lib/currency.jsx'
import Util from '../../../lib/util.jsx'
import Input from '../../../common/form/input/input.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import PopupDescription from '../../../project/popup/popup_description/popup_description.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'
import InputNumber from '../../../common/form/input_number/input_number.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Button from '../../../common/common/button/button.jsx'
import FormVatAutoComplete from '../../../common/form/vat_autocomplete/vat_autocomplete.jsx'
import FormVatTypeSelect from '../../../common/form/vat_typeselect/vat_typeselect.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import { PHASE_TYPES } from '../../../../shared/constants'

const { minutesToDecimal } = require('../../../../shared/util/time')

class InvoiceViewItemBase extends Component {
  constructor (props) {
    super(props)

    this.data = {
      vatLevels: props.vatLevels,
      vatKeyword: '',
      labelTypeOptions: [
        {
          label: IntlUtil.convertMessage('project.viewBudget.typeNone'),
          value: ''
        },
        {
          label: IntlUtil.convertMessage('project.viewBudget.typeService'),
          value: 'Service'
        },
        {
          label: IntlUtil.convertMessage('project.viewBudget.typeProduct'),
          value: 'Product'
        }
      ],
      showExpand: false
    }

    this.state = {
      showItems: false
    }

    this._documentListener = this._handleDocumentClick.bind(this)
    this._references = {
      refInvoiceDatePicker: React.createRef(),
      description: React.createRef(),
      triggerDescription: React.createRef()
    }
  }

  static propTypes = {
    item: PropTypes.object,
    disabledEdit: PropTypes.bool,
    onItemCreate: PropTypes.func,
    onItemUpdate: PropTypes.func,
    onUpdateSubtotal: PropTypes.func,
    onUpdateEditable: PropTypes.func,
    onItemExpenseCreate: PropTypes.func,
    onItemExpenseUpdate: PropTypes.func,
    projectUsers: PropTypes.array,
    isTypeActual: PropTypes.bool,
    onUpdateTotal: PropTypes.func,
    isLocked: PropTypes.bool,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onRemove: PropTypes.func,
    onItemExpenseDelete: PropTypes.func,
    isCredit: PropTypes.bool,
    showDefaultVat: PropTypes.bool,
    dragItem: PropTypes.object,
    connectDragSource: PropTypes.func,
    vatLevels: PropTypes.array,
    onRemoveSubItem: PropTypes.func,
    disableDrag: PropTypes.bool,
    getItemPosition: PropTypes.func,
    onInsertItemInMiddle: PropTypes.func,
    showRate: PropTypes.bool,
    showTax: PropTypes.bool,
    taxRateVatOptions: PropTypes.array,
    showVatAutocomplete: PropTypes.bool,
    showLabelType: PropTypes.bool,
    hidePagebreak: PropTypes.bool,
    onCreateTaxRate: PropTypes.func,
    showRateWithoutTax: PropTypes.bool,
    showActivity: PropTypes.bool,
    isQuickbookConnected: PropTypes.bool,
    quickbookItems: PropTypes.array,
    reloadQuickbookItems: PropTypes.func,
    isDiscountPhase: PropTypes.bool,
    budget: PropTypes.object
  }

  render () {
    const { item, disabledEdit, isDiscountPhase } = this.props

    if (!item) {
      return null
    }

    if (item.type === 'text') {
      return <div className='activityitem'>{this._renderActivityText()}</div>
    } else if (isDiscountPhase) {
      return this._renderDiscountColumns()
    } else if (item.type === 'expense') {
      return (
        <div
          className={classnames('expenseitem', {
            hasnotitle: !item.bTitleCompleted
          })}
        >
          {this._renderActivityExpense()}
          {this.state.showItems && (
            <div className={`subitems${disabledEdit ? ' disabled' : ''}`}>
              {this._renderSubItems(item)}
            </div>
          )}
        </div>
      )
    } else if (item.type === 'pagebreak') {
      return this._renderPageBreaker()
    }

    return this._renderActivitySubtotal()
  }

  _onToggleExpand (ev) {
    ev.preventDefault()

    this.data.showExpand = !this.data.showExpand
    this.setState({ dataDate: new Date() })
  }

  /* Event handlers */
  _onBlurActivityText (value) {
    const item = this.props.item
    item.title = value
    item.editable = false

    if (!item.id && this.props.onItemCreate) {
      this.props.onItemCreate(item)
    } else {
      this.props.onItemUpdate(item, 'title')
    }
  }

  _handleDocumentClick (ev) {
    if (
      this.props.item.showAdd &&
      !Util.targetIsDescendant(ev, ReactDOM.findDOMNode(this))
    ) {
      this._onHideAddAction()
    }
  }

  _onChangeActivityText (value) {
    this.props.item.title = value
  }

  _onBlurActivitySummary (value) {
    const item = this.props.item
    item.summary = value
    item.editable = false

    if (item.id && this.props.onItemUpdate) {
      this.props.onItemUpdate(item, 'summary')
    }
  }

  _onChangeActivitySummary (value) {
    this.props.item.summary = value
  }

  _onKeyPressSummary (name, ev) {
    if (ev.shiftKey && ev.key === 'Enter') {
      ev.preventDefault()
      ev.stopPropagation()
      return false
    }
    return true
  }

  _onChangeActivityDesc (name, value) {
    const item = this.props.item
    item[name] = value

    if (this.props.onItemUpdate) {
      this.props.onItemUpdate(item, 'description')
    }

    this.setState({ dataDate: new Date() })
  }

  _onChangeActivityInput (name, value) {
    const item = this.props.item
    item[name] = value

    if (name === 'noHours' || name === 'discountPercentage' || name === 'pricePerHour') {
      item.bUseTotal = false
    } else if (name === 'total') {
      item.bUseTotal = true
      item.noHours = 0
      item.pricePerHour = 0
    }

    item.bUpdateTotal = false
    item.bSaveItem = true

    if (name === 'vat' && this.props.onItemUpdate) {
      item.vat = parseInt(value, 10)
      this.props.onItemUpdate(item, name)
    }

    if (
      _.findIndex(
        ['noHours', 'pricePerHour', 'total', 'vat', 'discountPercentage'],
        itmName => itmName === name
      ) >= 0
    ) {
      item.bUpdateTotal = true
    }

    this._onChange()
  }

  _onClickHours (ev) {
    if (!this.props.isTypeActual) {
      return
    }

    ev.preventDefault()
    this.setState({ showItems: !this.state.showItems })
  }

  _updateActivityTotal (name, _value) {
    const { item, budget } = this.props
    const columns = ['noHours', 'pricePerHour', 'total', 'discountPercentage']

    if (item.type !== 'expense' || !columns.includes(name)) {
      return
    }

    if (name === 'discountPercentage') {
      const totalAmount = (budget?.phases || [])
        .filter(phase => phase.type !== PHASE_TYPES.DISCOUNT)
        .reduce((prevValue, currValue) => prevValue + currValue.total, 0)

      item.total = totalAmount * (item.discountPercentage / 100) || 0

      return
    }

    if (item.noHours && item.pricePerHour) {
      item.total = parseFloat(item.noHours) * parseFloat(item.pricePerHour)
    } else {
      item.total = item.bUseTotal ? item.total : 0
    }

    if (name === 'pricePerHour') {
      item.spentAmount = item.timeSpent
        ? item.pricePerHour * (item.timeSpent / 60)
        : 0
    }
  }

  _onBlurActivityInput (name, ev) {
    this._updateActivityTotal(name, this.props.item.total)
    if (!this._handleActivityInputChanged(name, true, false, ev)) {
      ev.preventDefault()
      ev.stopPropagation()
    }

    return true
  }

  _onKeyPressActivityInput (name, ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      this._updateActivityTotal(name, this.props.item.total)

      if (
        this._handleActivityInputChanged(name, false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _onKeyPressActivityVatInput (name, ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      this._updateActivityTotal(name, this.props.item.total)

      if (
        this._handleActivityInputChanged(name, false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _handleActivityInputChanged (name, bBlur, bEnter, ev) {
    const { item, isDiscountPhase } = this.props
    const bEsc = ev.keyCode === 27

    if (!item.title) {
      return false
    }

    if (bBlur) {
      item.bTitleCompleted = item.title
      item.editable = false
    } else {
      if (item.type === 'expense') {
        if (name === 'title') {
          item.bTitleCompleted = !!item.title
        }

        let editable = false
        if (!bEnter) {
          if (name === 'title') {
            editable = this.props.showTax
              ? 'vat'
              : this.props.showActivity
              ? 'total'
              : 'noHours'
          } else if (name === 'noHours') {
            editable = 'pricePerHour'
          } else if (name === 'pricePerHour') {
            editable = this.props.showDefaultVat
              ? 'summary'
              : this.props.showRateWithoutTax
              ? 'total'
              : 'vat'
          } else if (name === 'vat') {
            editable = 'total'
          } else if (name === 'total') {
            editable = 'summary'
            this.data.showExpand = true
          } else if (name === 'summary') {
            editable = false
          }

          if (isDiscountPhase) {
            if (name === 'title') {
              editable = 'discountPercentage'
            } else if (name === 'discountPercentage') {
              editable = 'vat'
            }
          }
        }

        item.editable = !item.bEdit || !bEsc ? editable : false

        if (item.editable === 'vat') {
          this.data.vatKeyword =
            item.vat || item.vat === 0 ? item.vat.toString() : ''
        }
      }
    }

    if (item.bTitleCompleted) {
      const updateFields = [name]

      if (name === 'noHours') {
        updateFields.push('total', 'bUseTotal', 'pricePerHour')
      } else if (name === 'pricePerHour') {
        updateFields.push('total', 'bUseTotal', 'noHours')
      } else if (name === 'total') {
        updateFields.push('noHours', 'pricePerHour', 'bUseTotal')
      } else if (name === 'discountPercentage') {
        updateFields.push('discountPercentage', 'total')
      }

      const bUpdateTotal = item.bUpdateTotal
      const bSaveItem = item.bSaveItem

      delete item.bUpdateTotal
      delete item.bSaveItem

      if (bSaveItem) {
        if (!item.id && this.props.onItemCreate) {
          this.props.onItemCreate(item)
          this._onSave()
        } else {
          this.props.onItemUpdate(item, updateFields)

          // Update invoice budget and phases
          if (bUpdateTotal) {
            this.props.onUpdateTotal()
          }
        }
      }
    }

    if (!item.editable && !bBlur) {
      if (bEnter) {
        if (this.props.onInsertItemInMiddle) {
          this.props.onInsertItemInMiddle(item.type, ev)
        }
      } else {
        this._updateActivity()
      }
    }

    this.setState({ dataDate: new Date() })
    return true
  }

  _updateActivity () {
    if (this.props.onUpdateEditable) {
      this.props.onUpdateEditable(this.props.item)
      this._onChange()
    }
  }

  _onEditActivity (name) {
    if (this.props.isLocked || this.props.disabledEdit) {
      return
    }

    const item = this.props.item
    item.editable = name
    item.bEdit = true

    if (name === 'vat') {
      this.data.vatKeyword =
        item[name] || item[name] === 0 ? item[name].toString() : ''
    }

    this._onChange()
  }

  _onEditExpense (name, expense, _invoiceItem) {
    if (this.props.disabledEdit) {
      return
    }

    expense.editable = name
    this.setState({ dataDate: new Date() })
  }

  _onChangeExpenseInput (name, expense, value) {
    const item = expense
    item.bSaveItem = true

    if (name === 'noHours') {
      item.noHours = this._parseTextToMinutes(value)
    } else {
      item[name] = value
    }
  }

  _onChangeActivityVatKeyword (item, value) {
    this.data.vatKeyword = value
    this.data.showVatAdd = false

    let vatIndex = 0

    if (item.labelType !== '') {
      vatIndex = _.findIndex(this.props.taxRateVatOptions, opt => {
        const vatValue = parseFloat(this.data.vatKeyword) || ''
        return opt.value === vatValue
      })
    }

    if (this.data.vatKeyword && vatIndex < 0) {
      this.data.showVatAdd = true
    }

    this.setState({ dataDate: new Date() })
  }

  _onChangeActivityVat (name, object) {
    const value = object.value
    const item = this.props.item
    item[name] = value
    item.bSaveItem = true
    item.editable = false

    if (name === 'vat' && this.props.onItemUpdate) {
      item.vat = parseFloat(value)
      this.props.onItemUpdate(item, name)
    }

    this._onChange()
  }

  _onSelectActivityVat (vatObj) {
    this.data.showVatAdd = false
    this._onChangeActivityVat('vat', vatObj)
  }

  _onSaveVat (vatObj) {
    const item = this.props.item

    this.data.showVatAdd = false

    this._onChangeActivityVat('vat', vatObj)

    if (this.props.onCreateTaxRate) {
      this.props.onCreateTaxRate({
        title: vatObj.label,
        isService: item.labelType === 'Service',
        isProduct: item.labelType === 'Product',
        percentage: parseFloat(vatObj.value)
      })
    }
  }

  _onBlurVat () {
    this.data.showVatAdd = false
    this.props.item.editable = false

    this.setState({ dataDate: new Date() })
  }

  _onKeyPressVat (ev) {
    this.data.vatKeyword = ''

    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      if (
        this._handleActivityInputChanged('vat', false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _parseTextToMinutes (value) {
    let timeTaken = 0
    if (/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(value)) {
      const timeArr = value.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }
    }

    return timeTaken
  }

  _onBlurExpenseInput (name, expense, invoiceItem, ev) {
    if (
      !this._handleExpenseInputChanged(name, true, expense, invoiceItem, ev)
    ) {
      ev.preventDefault()
      ev.stopPropagation()
    }

    return true
  }

  _onKeyPressExpenseInput (name, expense, invoiceItem, ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      if (
        this._handleExpenseInputChanged(name, false, expense, invoiceItem, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _handleExpenseInputChanged (name, bBlur, expense, invoiceItem, ev) {
    const bEsc = ev.keyCode === 27
    const item = expense
    let bUpdateTotal = false
    if (!item.expenseDate) {
      return false
    }

    const bSaveItem = item.bSaveItem
    delete item.bSaveItem

    if (bBlur) {
      item.editable = false

      if (item.type === 'expense' || item.type === 'time') {
        if (
          name === 'purchasePrice' ||
          name === 'sellingPrice' ||
          name === 'noHours' ||
          name === 'pricePerHour'
        ) {
          bUpdateTotal = true
        }
      }
    } else {
      let editable = false
      if (item.type === 'expense') {
        if (name === 'description') {
          editable = 'purchasePrice'
        } else if (name === 'purchasePrice') {
          bUpdateTotal = true
          editable = 'sellingPrice'
        } else if (name === 'sellingPrice') {
          bUpdateTotal = true
          editable = false
        }
      } else if (item.type === 'time') {
        if (name === 'userId') {
          editable = 'description'
        } else if (name === 'description') {
          editable = 'noHours'
        } else if (name === 'noHours') {
          bUpdateTotal = true
          editable = 'pricePerHour'
        } else if (name === 'pricePerHour') {
          bUpdateTotal = true
          editable = false
        }
      }

      item.editable = !item.bEdit || !bEsc ? editable : false
    }

    if (bSaveItem) {
      if (!item.id && this.props.onItemExpenseCreate) {
        this.props.onItemExpenseCreate(item, invoiceItem.id)
      } else {
        this.props.onItemExpenseUpdate(item, name)
      }

      if (this.props.isTypeActual && bUpdateTotal) {
        this._onUpdateTotalBySubItems()
      } else {
        this._onSave()
      }
    }

    this.setState({ dataDate: new Date() })
    return true
  }

  _onChangeExpenseUser (item, invoiceItem, object) {
    const value = object.value
    item.userId = value
    item.bSaveItem = true

    if (item.expenseDate) {
      if (!item.id && this.props.onItemExpenseCreate) {
        this.props.onItemExpenseCreate(item, invoiceItem.id)
      } else {
        this.props.onItemExpenseUpdate(item, 'userId')
      }
    }

    this.setState({ dataDate: new Date() })
  }

  _onChangeExpenseDate (name, expense, value) {
    expense[name] = value
    expense.bSaveItem = true

    this.props.onItemExpenseUpdate(expense, name)
    this.setState({ dataDate: new Date() })
  }

  _onFocus (_name, _value) {
    if (this._references.refInvoiceDatePicker.current) {
      this._references.refInvoiceDatePicker.current.showDatePicker()
    }
  }

  _onEditDescription () {
    const item = this.props.item
    if (this._references.description.current) {
      this._references.description.current.show(item.title)
    }
    this.forceUpdate()
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.props.item)
    }
  }

  _onSave () {
    if (this.props.onSave) {
      this.props.onSave(this.props.item)
    }
  }

  _onUpdateTotalBySubItems () {
    const item = this.props.item
    let itemTotal = 0
    let totalHours = 0

    item.expenses.forEach(subItem => {
      if (subItem.type === 'expense') {
        itemTotal += parseFloat(subItem.expenseTotal)
      } else {
        itemTotal += parseFloat(subItem.timeTotal)
        totalHours += subItem.noHours
      }
    })

    item.total = itemTotal
    item.noHours = totalHours
    this.setState({ dataDate: new Date() })

    this.props.onUpdateSubtotal()
    this.props.onUpdateTotal()
    app.service('/api/invoice/item').patch(item.id, { noHours: totalHours })
  }

  _onRemoveItem (e) {
    e.preventDefault()

    if (this.props.onRemove && !this.props.disabledEdit) {
      this.props.onRemove()
    }
  }

  _onRemoveSubItem (subItem, subItemIdx, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    const item = this.props.item

    if (subItem.id && this.props.onRemoveSubItem) {
      this.props.onRemoveSubItem(item, subItem, () => {
        _.remove(item.expenses, (obj, _idx) => obj.id === subItem.id)
        this._onUpdateTotalBySubItems()
        this.setState({ dataDate: new Date() })
      })
    } else {
      _.remove(item.expenses, (obj, idx) => {
        if (obj.id === null && idx === subItemIdx) {
          return true
        }

        return false
      })
      this._onUpdateTotalBySubItems()
      this.setState({ dataDate: new Date() })
    }
  }

  _createEmptyItemExpense (type) {
    const item = this.props.item

    // Check already empty item is added and not saved
    const emptyItem = _.find(item.expenses, obj => !obj.id)
    if (!emptyItem) {
      item.expenses.push({
        id: null,
        expenseDate: null,
        teamId: item.teamId,
        invoiceId: item.invoiceId,
        invoiceItemId: item.id,
        type: type,
        budgetItemId: null,
        expenseId: null,
        timecardId: null,
        description: '',
        userId: item.userId,
        purchasePrice: 0,
        sellingPrice: 0,
        expenseTotal: 0,
        noHours: 0,
        pricePerHour: 0,
        timeTotal: 0,
        external: false
      })

      this.setState({ dataDate: new Date() })
    }
  }

  /* Private functions */
  _renderActivityExpense () {
    const {
      dragItem,
      item,
      isLocked,
      disabledEdit
    } = this.props
    const _className = classnames('phaseitem', 'phaseitem_normal', {
      phaseitem_isdragging: dragItem && dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem,
      phaseitem_disabled: disabledEdit,
      dropopen: this.data.showExpand
    })

    const connectDragSource = this.props.connectDragSource ? this.props.connectDragSource : this._connectDragSource
    const _hoursClass = `viewcol colhours ${item.expenses && item.expenses.length > 0 ? 'colhours_alt' : ''}`

    const noHours = item.external ? minutesToDecimal(item.noHours) : item.noHours

    let className = 'cont'
    if (this.props.showTax) {
      className = 'cont showtax'
    } else if (this.props.showRate) {
      className = 'cont showrate'
    } else if (this.props.showRateWithoutTax) {
      className = 'cont showratewithouttax'
    } else {
      className = 'cont showactivity'
    }

    const bHidePriceEdit = !!item.bUseTotal

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          {isLocked ? (
            <span className='phaseitem-lock'>
              <i className='icon icon-invoice-lock' />
            </span>
          ) : (
            <span
              className='phaseitem-close'
              onClick={this._onRemoveItem.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          <div className={className}>
            <div className={`splitterwrap splitterwrap-${className}`}>
              <div className='splitteritem col1' />
              <div className='splitteritem col2' />
              <div className='splitteritem col3' />
            </div>
            {this._renderTitleColumn()}
            {this.props.isTypeActual &&
            item.external &&
            !this.props.isCredit ? (
              <div className={_hoursClass}>
                <span className='ninfo' onClick={this._onClickHours.bind(this)}>
                  {noHours}
                  <span className='iconcont'>
                    <i className='icon icon-grid-downarw' />
                  </span>
                </span>
              </div>
            ) : (
              <div className='viewcol colhours'>
                {item.editable === 'noHours' ? (
                  <span className='label'>
                    <InputNumber
                      type='text'
                      name='noHours'
                      maxLength={120}
                      label='invoice.view.labelHoursUnits'
                      required
                      className='invoice'
                      validations={['required']}
                      value={item.noHours}
                      autoFocus
                      onChange={this._onChangeActivityInput.bind(
                        this,
                        'noHours'
                      )}
                      onBlur={this._onBlurActivityInput.bind(this, 'noHours')}
                      onKeyDown={this._onKeyPressActivityInput.bind(
                        this,
                        'noHours'
                      )}
                    />
                  </span>
                ) : bHidePriceEdit ? (
                  <span
                    className='ninfo alt'
                    onClick={this._onEditActivity.bind(this, 'noHours')}
                  >
                    <IntlMessage ident='invoice.view.totalPriceNull' />
                  </span>
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditActivity.bind(this, 'noHours')}
                  >
                    {item.noHours
                      ? currency.format(item.noHours)
                      : currency.format(0)}
                  </span>
                )}
              </div>
            )}
            {this.props.isTypeActual && item.external ? (
              <div className='viewcol colrate default'>&nbsp;</div>
            ) : (
              <div className='viewcol colrate'>
                {item.editable === 'pricePerHour' ? (
                  <span className='label'>
                    <InputPrice
                      type='text'
                      name='pricePerHour'
                      maxLength={120}
                      label='invoice.view.labelRatePrice'
                      required
                      className='invoice'
                      autoFocus
                      validations={['required']}
                      value={item.pricePerHour}
                      prefixCurrency={currency.symbol()}
                      onChange={this._onChangeActivityInput.bind(
                        this,
                        'pricePerHour'
                      )}
                      onBlur={this._onBlurActivityInput.bind(
                        this,
                        'pricePerHour'
                      )}
                      onKeyDown={this._onKeyPressActivityInput.bind(
                        this,
                        'pricePerHour'
                      )}
                    />
                  </span>
                ) : bHidePriceEdit ? (
                  <span
                    className='ninfo alt'
                    onClick={this._onEditActivity.bind(this, 'pricePerHour')}
                  >
                    <IntlMessage ident='invoice.view.totalPriceNull' />
                  </span>
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditActivity.bind(this, 'pricePerHour')}
                  >
                    <PriceText value={item.pricePerHour} />
                  </span>
                )}
              </div>
            )}
            {this._renderVatColumn()}
            {this._renderPriceColumn()}
          </div>
          {this._renderSubContent()}
          {connectDragSource(
            <div className='hovericon'>
              <span className='iconcont'>
                <i className='icon icon-budget-listmenu' />
              </span>
            </div>
          )}
        </div>
        {this._renderAddAction()}
      </div>
    )
  }

  _renderVatColumn () {
    const {
      item,
      showVatAutocomplete,
      taxRateVatOptions,
      showDefaultVat
    } = this.props

    const vatOptions = []
    taxRateVatOptions.forEach(vatOpt => {
      const vatType = vatOpt.isService
        ? 'Service'
        : vatOpt.isProduct
        ? 'Product'
        : ''
      let bVatMatch = false

      if (this.data.vatKeyword !== '0' && this.data.vatKeyword) {
        const vatValue =
          vatOpt.value !== undefined ? vatOpt.value.toString() : ''
        if (vatValue && vatValue.includes(this.data.vatKeyword)) {
          bVatMatch = true
        }
      } else {
        bVatMatch = true
      }

      if (bVatMatch) {
        if (item.labelType === '') {
          vatOptions.push(vatOpt)
        } else if (vatType === item.labelType) {
          vatOptions.push(vatOpt)
        }
      }
    })

    if (showDefaultVat) {
      return (
        <div className='viewcol colvat'>
          <span className='ninfo'>{item.vat} %</span>
        </div>
      )
    }

    return (
      <div className='viewcol colvat'>
        {item.editable === 'vat' ? (
          <span className='label'>
            {showVatAutocomplete ? (
              <FormVatAutoComplete
                name='vat'
                autoFocus
                value={item.vat}
                displayValue={this.data.vatKeyword}
                options={vatOptions}
                onChange={this._onChangeActivityVatKeyword.bind(
                  this,
                  item
                )}
                onSelect={this._onSelectActivityVat.bind(this)}
                showAdd={false}
                showVatAdd={
                  this.data.vatKeyword && this.data.showVatAdd
                }
                showSelection
                hasAutoSelect={false}
                keywordLength={0}
                bShowButton
                onSaveVat={this._onSaveVat.bind(this)}
                onBlur={this._onBlurVat.bind(this)}
                onKeyDown={this._onKeyPressVat.bind(this)}
              />
            ) : (
              <ReactSelect
                name='vat'
                className='select-alt select-itemvat vat'
                value={
                  _.find(
                    this.data.vatLevels,
                    obj => obj.value === item.vat
                  ) || null
                }
                options={this.data.vatLevels}
                classNamePrefix='typeitem'
                clearable={false}
                openOnFocus
                onChange={this._onChangeActivityVat.bind(this, 'vat')}
                onBlur={this._onBlurActivityInput.bind(this, 'vat')}
                onInputKeyDown={this._onKeyPressActivityVatInput.bind(
                  this,
                  'vat'
                )}
              />
            )}
          </span>
        ) : (
          <span
            className='ninfo'
            onClick={this._onEditActivity.bind(this, 'vat')}
          >
            {item.vat} %
          </span>
        )}
      </div>
    )
  }

  _renderTitleColumn () {
    const {
      item,
      disabledEdit
    } = this.props

    return (
      <div className='viewcol colname'>
        {item.editable === 'title' ? (
          <Input
            type='text'
            name='title'
            maxLength={120}
            label='invoice.view.labelNewLine'
            required
            className='invoice'
            validations={['required']}
            value={item.title}
            autoFocus
            onChange={this._onChangeActivityInput.bind(this, 'title')}
            onBlur={this._onBlurActivityInput.bind(this, 'title')}
            onKeyDown={this._onKeyPressActivityInput.bind(this, 'title')}
          />
        ) : (
          <div className='info ninfo'>
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'title')}
            >
              <span className='value'>{item.title}</span>
            </div>
            {!disabledEdit && (
              <div className='action'>
                {item.description ? (
                  <span
                    className='desc active'
                    ref={this._references.triggerDescription}
                  >
                    <i
                      className='icon icon-phase-description-hover'
                      ref={this._references.triggerDescription}
                      onClick={this._onEditDescription.bind(this)}
                    />
                  </span>
                ) : (
                  <span
                    className='desc canhover'
                    ref={this._references.triggerDescription}
                  >
                    <i
                      className='icon icon-phase-description'
                      onClick={this._onEditDescription.bind(this)}
                    />
                    <i
                      className='icon icon-phase-description-hover hover'
                      onClick={this._onEditDescription.bind(this)}
                    />
                  </span>
                )}
              </div>
            )}
            {!disabledEdit && (
              <PopupDescription
                ref={this._references.description}
                description={item.description}
                target={this._references.triggerDescription.current}
                container={this}
                onChange={this._onChangeActivityDesc.bind(
                  this,
                  'description'
                )}
              />
            )}
          </div>
        )}
      </div>
    )
  }

  _renderPriceColumn (params = { disableUpdates: false }) {
    const { item } = this.props

    if (params.disableUpdates || item.editable !== 'total') {
      return (
        <div className='viewcol colprice'>
          <span className='ninfo'>
            <PriceText value={item.total} />
          </span>
        </div>
      )
    }

    return (
      <div className='viewcol colprice'>
        {item.editable === 'total' ? (
          <div className='label'>
            <InputPrice
              type='text'
              name='total'
              maxLength={120}
              label='invoice.view.labeltotal'
              required
              className='invoice inlinesmall-input'
              autoFocus
              validations={['required']}
              value={item.total}
              prefixCurrency={currency.symbol()}
              onChange={this._onChangeActivityInput.bind(this, 'total')}
              onBlur={this._onBlurActivityInput.bind(this, 'total')}
              onKeyDown={this._onKeyPressActivityInput.bind(this, 'total')}
            />
          </div>
        ) : (
          <span
            className='ninfo'
            onClick={this._onEditActivity.bind(this, 'total')}
          >
            <PriceText value={item.total} />
          </span>
        )}
      </div>
    )
  }

  _renderSubContent () {
    const { item, showLabelType } = this.props
    const bHasSubCont = item.type === 'expense'
    const bShowLabelType = !!showLabelType

    return (
      <>
        {bHasSubCont && !this.data.showExpand && (
          <span
            className='itemaccordion'
            onClick={this._onToggleExpand.bind(this)}
          >
            <i className='icon icon-grid-expand normal' />
          </span>
        )}
        {bHasSubCont && this.data.showExpand && (
          <span
            className='itemaccordion'
            onClick={this._onToggleExpand.bind(this)}
          >
            <i className='icon icon-planner-accordionclose' />
          </span>
        )}
        {bHasSubCont && (
          <div className='itemsubcont'>
            <div className='viewcol colsummary'>
              <div className='col coltitle coltitle_text typo typo_viewsummary'>
                {item.editable === 'summary' ? (
                  <WysiwygEditor
                    placeholder='invoice.view.enterDescription'
                    value={item.summary}
                    onBlur={this._onBlurActivitySummary.bind(this)}
                    onChange={this._onChangeActivitySummary.bind(this)}
                    onKeyDown={this._onKeyPressSummary.bind(this, 'summary')}
                    autoFocus
                  />
                ) : (
                  <div
                    className='label'
                    onClick={this._onEditActivity.bind(this, 'summary')}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          item.summary ||
                          IntlUtil.convertMessage('invoice.view.labelSummary')
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            {bShowLabelType && (
              <div className='infocont'>
                <div className='dropcol coltitle'>
                  <div
                    className='label infocol'
                    onClick={this._onEditActivity.bind(this, 'labelType')}
                  >
                    <div className='info infoservice'>
                      <IntlMessage ident='project.viewBudget.labelInitialLabelType' />
                    </div>
                    &nbsp;
                    <div className='value infoservice'>
                      <FormVatTypeSelect
                        name='labelType'
                        value={item.labelType}
                        disabled={this.props.disabledEdit}
                        isQuickbookConnected={this.props.isQuickbookConnected}
                        quickbookItems={this.props.quickbookItems}
                        onChange={this._onChangeActivityLabelType.bind(
                          this,
                          'labelType'
                        )}
                        onBlur={this._onBlurActivityInput.bind(
                          this,
                          'labelType'
                        )}
                        onInputKeyDown={this._onKeyPressActivityVatInput.bind(
                          this,
                          'labelType'
                        )}
                        reloadQuickbookItems={this.props.reloadQuickbookItems}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </>
    )
  }

  _renderAddAction () {
    const { item } = this.props

    return (
      <>
        {!item.showAdd && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowAddAction.bind(this, item)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
        {item.showAdd && this._renderActivityAction()}
      </>
    )
  }

  _renderDiscountColumn () {
    const { item } = this.props

    return (
      <div className='viewcol coldiscount'>
        {item.editable === 'discountPercentage' ? (
          <span className='label'>
            <InputPrice
              type='text'
              name='discountPercentage'
              maxLength={4}
              required
              className='invoice'
              autoFocus
              validations={['required']}
              value={item.discountPercentage}
              prefixCurrency={currency.symbol()}
              onChange={this._onChangeActivityInput.bind(this, 'discountPercentage')}
              onBlur={this._onBlurActivityInput.bind(this, 'discountPercentage')}
              onKeyDown={this._onKeyPressActivityInput.bind(this, 'discountPercentage')}
            />
          </span>
        ) : (
          <span
            className='ninfo'
            onClick={this._onEditActivity.bind(this, 'discountPercentage')}
          >
            <span className='value'>{item.discountPercentage}%</span>
          </span>
        )}
      </div>
    )
  }

  _renderDiscountColumns () {
    const {
      isLocked,
      disabledEdit
    } = this.props
    const _className = classnames('phaseitem', 'phaseitem_normal', {
      phaseitem_disabled: disabledEdit,
      dropopen: this.data.showExpand
    })

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          {isLocked ? (
            <span className='phaseitem-lock'>
              <i className='icon icon-invoice-lock' />
            </span>
          ) : (
            <span
              className='phaseitem-close'
              onClick={this._onRemoveItem.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          <div className='cont'>
            <div className='splitterwrap splitterwrap-cont'>
              <div className='splitteritem col1' />
              <div className='splitteritem col2' />
            </div>
            {this._renderTitleColumn()}
            {this._renderDiscountColumn()}
            {this._renderVatColumn()}
            {this._renderPriceColumn({ disableUpdates: true })}
          </div>

          {this._renderSubContent()}
        </div>
        {this._renderAddAction()}
      </div>
    )
  }

  _onShowAddAction (item, ev) {
    ev.preventDefault()

    document.addEventListener('click', this._documentListener)

    this.props.item.showAdd = true
    this.setState({ dataDate: new Date() })
  }

  _renderActivityAction () {
    if (this.props.disabledEdit || this.props.isLocked) {
      return ''
    }
    const hidePagebreak = this.props.hidePagebreak

    return (
      <div className='phaseactions'>
        <span
          className='phaseitem-close'
          onClick={this._onHideAddAction.bind(this)}
        >
          <i className='icon icon-phase-close' />
        </span>
        <div className='action'>
          <Button
            className='button_phase'
            title='invoice.view.expense'
            onClick={this._onInsertItemInMiddle.bind(this, 'expense')}
          />
          <Button
            className='button_phase'
            title='invoice.view.text'
            onClick={this._onInsertItemInMiddle.bind(this, 'text')}
          />
          {!hidePagebreak && (
            <Button
              className='button_phase'
              title='invoice.view.pageBreaker'
              onClick={this._onInsertItemInMiddle.bind(this, 'pagebreak')}
            />
          )}
        </div>
      </div>
    )
  }

  _onInsertItemInMiddle (type, ev) {
    ev.preventDefault()

    if (this.props.onInsertItemInMiddle) {
      this.props.onInsertItemInMiddle(type, ev)
    }
  }

  _onHideAddAction () {
    document.removeEventListener('click', this._documentListener, false)

    this.props.item.showAdd = false
    this.setState({ dataDate: new Date() })
  }

  _onChangeActivityLabelType (name, object) {
    const value = object.value
    const item = this.props.item
    item[name] = value
    item.bSaveItem = true

    if (name === 'labelType' && this.props.onItemUpdate) {
      item.labelType = value
      this.props.onItemUpdate(item, name)
    }

    this._onChange()
  }

  _renderActivityText () {
    const { dragItem, item, disabledEdit, isDiscountPhase } = this.props
    const _className = classnames('phaseitem', 'phaseitem_text', {
      phaseitem_isdragging: dragItem && dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem,
      disabled: disabledEdit
    })
    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          <span
            className='phaseitem-close'
            onClick={this._onRemoveItem.bind(this)}
          >
            <i className='icon icon-phase-close' />
          </span>
          <div className='cont'>
            <div className='col coltitle coltitle_text typo wysiwygtypo'>
              {item.editable === 'title' ? (
                <WysiwygEditor
                  placeholder='invoice.view.enterDescription'
                  value={item.title}
                  onBlur={this._onBlurActivityText.bind(this)}
                  onChange={this._onChangeActivityText.bind(this)}
                  onKeyDown={this._onKeyPressSummary.bind(this, 'title')}
                  autoFocus
                />
              ) : (
                <div
                  className='label'
                  onClick={this._onEditActivity.bind(this, 'title')}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.title }} />
                </div>
              )}
            </div>
          </div>
          {!isDiscountPhase && connectDragSource(
            <div className='hovericon'>
              <span className='iconcont'>
                <i className='icon icon-budget-listmenu' />
              </span>
            </div>
          )}
        </div>
        {!item.showAdd && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowAddAction.bind(this, item)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
        {item.showAdd && this._renderActivityAction()}
      </div>
    )
  }

  _renderPageBreaker () {
    const { dragItem, item, disabledEdit, disableDrag } = this.props
    const _className = classnames('phaseitem', 'phaseitem_pagebreaker', {
      phaseitem_isdragging: dragItem && dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem,
      phaseitem_disabled: disabledEdit
    })
    const connectDragSource =
      this.props.connectDragSource && !disableDrag
        ? this.props.connectDragSource
        : this._connectDragSource

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          <span
            className='phaseitem-close'
            onClick={this._onRemoveItem.bind(this)}
          >
            <i className='icon icon-phase-close' />
          </span>
          <div className='cont'>
            <div className='col colbreaker'>
              <IntlMessage ident='invoice.view.pageBreaker' />
            </div>
          </div>
          {!disableDrag &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
        </div>
        {!item.showAdd && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowAddAction.bind(this, item)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
        {item.showAdd && this._renderActivityAction()}
      </div>
    )
  }

  _renderActivitySubtotal () {
    const { dragItem, item } = this.props
    const _className = classnames('phaseitem', 'subtotal', {
      phaseitem_isdragging: dragItem && dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem
    })
    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource
    const subtotal = item.total ? item.total : 0

    return (
      <div className={_className}>
        <span
          className='phaseitem-close'
          onClick={this._onRemoveItem.bind(this)}
        >
          <i className='icon icon-phase-close' />
        </span>
        <div className='col colsubtotal'>
          <span className='label'>
            <IntlMessage ident='invoice.view.labelSubTotal' />
          </span>
          <span className='value'>
            <PriceText value={subtotal} />
          </span>
        </div>
        {connectDragSource(
          <div className='hovericon'>
            <span className='iconcont'>
              <i className='icon icon-budget-listmenu' />
            </span>
          </div>
        )}
      </div>
    )
  }

  _renderSubItems (item) {
    if (item.expenses && item.expenses.length > 0) {
      return item.expenses.map((expense, idx) => {
        if (expense.type === 'expense') {
          return this._renderExpenseItem(item, expense, idx)
        } else if (expense.type === 'time') {
          return this._renderTimeItem(item, expense, idx)
        }
      })
    }

    return ''
  }

  _connectDragSource (node) {
    return node
  }

  _renderTimeItem (invoiceItem, time, idx) {
    return (
      <div className='activitysubitem' key={idx}>
        {idx === 0 && this._renderTimeHeader()}
        <div className='phaseitem phaseitem_small phaseitem_activitysubitem'>
          <div className='phaseitem-inner'>
            <span
              className='phaseitem-close'
              onClick={this._onRemoveSubItem.bind(this, time, idx)}
            >
              <i className='icon icon-phase-close' />
            </span>
            <div className='cont'>
              <div className='viewcol coldate'>
                <FormDatePicker
                  placeholder='invoice.view.labelDate'
                  ref={this._references.refInvoiceDatePicker}
                  value={time.expenseDate ? new Date(time.expenseDate) : null}
                  name='expenseDate'
                  onChange={this._onChangeExpenseDate.bind(
                    this,
                    'expenseDate',
                    time
                  )}
                  onFocus={this._onFocus.bind(this, 'expenseDate')}
                />
              </div>
              <div className='viewcol colteam'>
                <span className='label'>
                  <ReactSelect
                    name='userId'
                    value={
                      _.find(
                        this.props.projectUsers,
                        obj => obj.value === time.userId
                      ) || null
                    }
                    className='select-alt invoiceuserselect'
                    options={this.props.projectUsers}
                    clearable={false}
                    openOnFocus
                    classNamePrefix='invoiceselectitem'
                    onChange={this._onChangeExpenseUser.bind(
                      this,
                      time,
                      invoiceItem
                    )}
                  />
                </span>
              </div>
              <div className='viewcol coldesc'>
                {time.editable === 'description' ? (
                  <WysiwygEditor
                    type='text'
                    name='description'
                    maxLength={120}
                    label='invoice.view.labelDescription'
                    required
                    className='invoice'
                    value={time.description}
                    autoFocus
                    onChange={this._onChangeExpenseInput.bind(
                      this,
                      'description',
                      time
                    )}
                    onBlur={this._onBlurExpenseInput.bind(
                      this,
                      'description',
                      time,
                      invoiceItem
                    )}
                    onKeyDown={this._onKeyPressExpenseInput.bind(
                      this,
                      'description',
                      time,
                      invoiceItem
                    )}
                  />
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditExpense.bind(
                      this,
                      'description',
                      time,
                      invoiceItem
                    )}
                    dangerouslySetInnerHTML={{
                      __html: time.description ? time.description : '-'
                    }}
                  />
                )}
              </div>
              <div className='viewcol colhours'>
                {time.editable === 'noHours' ? (
                  <span className='label'>
                    <Input
                      type='text'
                      name='noHours'
                      maxLength={120}
                      label='invoice.view.labelTimeHours'
                      required
                      className='invoice'
                      validations={['required']}
                      value={Util.convertMinutesToHour(time.noHours)}
                      autoFocus
                      onChange={this._onChangeExpenseInput.bind(
                        this,
                        'noHours',
                        time
                      )}
                      onBlur={this._onBlurExpenseInput.bind(
                        this,
                        'noHours',
                        time,
                        invoiceItem
                      )}
                      onKeyDown={this._onKeyPressExpenseInput.bind(
                        this,
                        'noHours',
                        time,
                        invoiceItem
                      )}
                    />
                  </span>
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditExpense.bind(
                      this,
                      'noHours',
                      time,
                      invoiceItem
                    )}
                  >
                    {time.noHours ? Util.convertMinutesToHour(time.noHours) : 0}
                    <span className='iconcont'>
                      <i className='icon icon-budget-listmenu' />
                    </span>
                  </span>
                )}
              </div>
              <div className='viewcol colrate'>
                {time.editable === 'pricePerHour' ? (
                  <span className='label'>
                    <InputPrice
                      type='text'
                      name='pricePerHour'
                      maxLength={120}
                      label='invoice.view.itemPriceLabel'
                      required
                      className='invoice'
                      autoFocus
                      validations={['required']}
                      value={time.pricePerHour}
                      prefixCurrency={currency.symbol()}
                      onChange={this._onChangeExpenseInput.bind(
                        this,
                        'pricePerHour',
                        time
                      )}
                      onBlur={this._onBlurExpenseInput.bind(
                        this,
                        'pricePerHour',
                        time,
                        invoiceItem
                      )}
                      onKeyDown={this._onKeyPressExpenseInput.bind(
                        this,
                        'pricePerHour',
                        time,
                        invoiceItem
                      )}
                    />
                  </span>
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditExpense.bind(
                      this,
                      'pricePerHour',
                      time,
                      invoiceItem
                    )}
                  >
                    {time.pricePerHour > 0 ? (
                      <PriceText value={time.pricePerHour} />
                    ) : (
                      '0,00'
                    )}
                  </span>
                )}
              </div>
              <div className='viewcol colprice'>
                <h2 className='moneyvalue'>
                  <span className='value'>
                    {time.timeTotal ? (
                      <PriceText value={time.timeTotal} />
                    ) : (
                      '0,00'
                    )}
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderExpenseItem (invoiceItem, expense, idx) {
    return (
      <div className='expensesubitem' key={idx}>
        {idx === 0 && this._renderExpenseHeader()}
        <div className='phaseitem phaseitem_small phaseitem_expensesubitem'>
          <div className='phaseitem-inner'>
            <span
              className='phaseitem-close'
              onClick={this._onRemoveSubItem.bind(this, expense, idx)}
            >
              <i className='icon icon-phase-close' />
            </span>
            <div className='cont'>
              <div className='viewcol coldate'>
                <FormDatePicker
                  placeholder='invoice.view.labelDate'
                  ref={this._references.refInvoiceDatePicker}
                  value={
                    expense.expenseDate ? new Date(expense.expenseDate) : null
                  }
                  name='expenseDate'
                  onChange={this._onChangeExpenseDate.bind(
                    this,
                    'expenseDate',
                    expense
                  )}
                  onFocus={this._onFocus.bind(this, 'expenseDate')}
                />
              </div>
              <div className='viewcol coldesc'>
                {expense.editable === 'description' ? (
                  <WysiwygEditor
                    type='text'
                    name='description'
                    maxLength={120}
                    label='invoice.view.labelDescription'
                    required
                    className='invoice'
                    value={expense.description}
                    autoFocus
                    onChange={this._onChangeExpenseInput.bind(
                      this,
                      'description',
                      expense
                    )}
                    onBlur={this._onBlurExpenseInput.bind(
                      this,
                      'description',
                      expense,
                      invoiceItem
                    )}
                    onKeyDown={this._onKeyPressExpenseInput.bind(
                      this,
                      'description',
                      expense,
                      invoiceItem
                    )}
                  />
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditExpense.bind(
                      this,
                      'description',
                      expense,
                      invoiceItem
                    )}
                    dangerouslySetInnerHTML={{
                      __html: expense.description ? expense.description : '-'
                    }}
                  />
                )}
              </div>
              <div className='viewcol colrate'>
                {expense.editable === 'purchasePrice' ? (
                  <span className='label'>
                    <InputPrice
                      type='text'
                      name='purchasePrice'
                      maxLength={120}
                      label='invoice.view.itemPriceLabel'
                      required
                      className='invoice'
                      autoFocus
                      validations={['required']}
                      value={expense.purchasePrice}
                      prefixCurrency={currency.symbol()}
                      onChange={this._onChangeExpenseInput.bind(
                        this,
                        'purchasePrice',
                        expense
                      )}
                      onBlur={this._onBlurExpenseInput.bind(
                        this,
                        'purchasePrice',
                        expense,
                        invoiceItem
                      )}
                      onKeyDown={this._onKeyPressExpenseInput.bind(
                        this,
                        'purchasePrice',
                        expense,
                        invoiceItem
                      )}
                    />
                  </span>
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditExpense.bind(
                      this,
                      'purchasePrice',
                      expense,
                      invoiceItem
                    )}
                  >
                    {expense.purchasePrice > 0 ? (
                      <PriceText value={expense.purchasePrice} />
                    ) : (
                      '0,00'
                    )}
                  </span>
                )}
              </div>
              <div className='viewcol colrate'>
                {expense.editable === 'sellingPrice' ? (
                  <span className='label'>
                    <InputPrice
                      type='text'
                      name='sellingPrice'
                      maxLength={120}
                      label='invoice.view.itemPriceLabel'
                      required
                      className='invoice'
                      autoFocus
                      validations={['required']}
                      value={expense.sellingPrice}
                      prefixCurrency={currency.symbol()}
                      onChange={this._onChangeExpenseInput.bind(
                        this,
                        'sellingPrice',
                        expense
                      )}
                      onBlur={this._onBlurExpenseInput.bind(
                        this,
                        'sellingPrice',
                        expense,
                        invoiceItem
                      )}
                      onKeyDown={this._onKeyPressExpenseInput.bind(
                        this,
                        'sellingPrice',
                        expense,
                        invoiceItem
                      )}
                    />
                  </span>
                ) : (
                  <span
                    className='ninfo'
                    onClick={this._onEditExpense.bind(
                      this,
                      'sellingPrice',
                      expense,
                      invoiceItem
                    )}
                  >
                    {expense.sellingPrice > 0 ? (
                      <PriceText value={expense.sellingPrice} />
                    ) : (
                      '0,00'
                    )}
                  </span>
                )}
              </div>
              <div className='viewcol colprice'>
                <h2 className='moneyvalue'>
                  <span className='value'>
                    {expense.expenseTotal ? (
                      <PriceText value={expense.expenseTotal} />
                    ) : (
                      '0,00'
                    )}
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderTimeHeader () {
    return (
      <div className='viewheader alt'>
        <div className='viewcol coldate'>
          <IntlMessage ident='invoice.view.titleDate' />
        </div>
        <div className='viewcol colteam'>
          <IntlMessage ident='invoice.view.titleTeamMember' />
        </div>
        <div className='viewcol coldesc'>
          <IntlMessage ident='invoice.view.titleDescription' />
        </div>
        <div className='viewcol colhours'>
          <IntlMessage ident='invoice.view.titleHours' />
        </div>
        <div className='viewcol colrate'>
          <IntlMessage ident='invoice.view.titleRate' />
        </div>
        <div className='viewcol colprice'>
          <IntlMessage ident='invoice.view.titlePriceExcl' />
        </div>
      </div>
    )
  }

  _renderExpenseHeader () {
    return (
      <div className='viewheader alt'>
        <div className='viewcol coldate'>
          <IntlMessage ident='invoice.view.titleDate' />
        </div>
        <div className='viewcol coldesc'>
          <IntlMessage ident='invoice.view.titleDescription' />
        </div>
        <div className='viewcol colrate'>
          <IntlMessage ident='invoice.view.titlePurchasePrice' />
          <IconButton
            icon='list-iteminfo'
            size='normal'
            canHover={false}
            className='invoiceinfo'
            tooltip='invoice.view.subitemInfo'
            tooltipPosition='top'
          />
        </div>
        <div className='viewcol colrate'>
          <IntlMessage ident='invoice.view.titleSellingPrice' />
        </div>
        <div className='viewcol colprice'>
          <IntlMessage ident='invoice.view.titlePriceExcl' />
        </div>
      </div>
    )
  }
}

export default InvoiceViewItemBase
